import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import NewsCard from "../../components/football/NewsCard";
import { HERO_IMAGES } from "../../lib/constants";
import api from "../../lib/api";

export default function College() {
    const [sb, setSb] = useState({ events: [] });
    const [polls, setPolls] = useState([]);
    const [news, setNews] = useState([]);

    useEffect(() => {
        api.get("/football/college/scoreboard").then(r => setSb(r.data)).catch(() => {});
        api.get("/football/college/rankings").then(r => setPolls(r.data.polls || [])).catch(() => {});
        api.get("/football/news", { params: { category: "College", limit: 12 } }).then(r => setNews(r.data)).catch(() => {});
    }, []);

    return (
        <PageLayout>
            <section className="relative pt-28 pb-12 border-b border-white/10 overflow-hidden">
                <img src={HERO_IMAGES.stadium_lights} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Digital Beast D1 Football</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="college-heading">
                        D1 <span className="text-[#d4af37]">COLLEGE FOOTBALL</span>
                    </h1>
                </div>
            </section>
            <TrendingBar />

            {polls[0] && (
                <section className="py-10" data-testid="college-rankings">
                    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                        <div className="section-label mb-4">{polls[0].name}</div>
                        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-3">
                            {polls[0].ranks.slice(0, 10).map(r => (
                                <div key={r.current} className="surface p-4 flex items-center gap-3" data-testid={`ap-rank-${r.current}`}>
                                    <div className="font-display text-4xl text-[#d4af37] w-10">{r.current}</div>
                                    {r.logo && <img src={r.logo} alt="" className="w-10 h-10" />}
                                    <div className="flex-1 min-w-0">
                                        <div className="text-white text-sm truncate">{r.team}</div>
                                        <div className="text-white/40 text-[10px]">{r.record}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            <section className="py-10 border-t border-white/10 bg-[#0a0a0a]" data-testid="college-scoreboard">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-4">Scoreboard</div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
                        {sb.events.slice(0, 12).map(e => (
                            <div key={e.id} className="surface p-4">
                                <div className="text-[10px] uppercase tracking-widest text-white/40 mb-3">{e.status}</div>
                                {e.teams.map(t => (
                                    <div key={t.id} className="flex items-center gap-3 py-1.5">
                                        {t.logo && <img src={t.logo} alt="" className="w-6 h-6" />}
                                        <div className="flex-1">
                                            <div className="text-white text-sm">{t.rank && <span className="text-[#d4af37] mr-1">#{t.rank}</span>}{t.name}</div>
                                        </div>
                                        <div className="font-display text-xl text-white">{t.score || "—"}</div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-10" data-testid="college-news-section">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="flex items-end justify-between mb-5">
                        <div><div className="section-label mb-2">Headlines</div><h2 className="font-display text-3xl text-white">College Football News</h2></div>
                        <Link to="/football/news?category=College" className="btn-ghost text-xs">All college news <ChevronRight size={12} /></Link>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
                        {news.map(n => <NewsCard key={n.id} item={n} testid={`college-news-${n.id}`} />)}
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
